import React from 'react';

import { ApCheckbox, ApIcon, colors } from '@alixpartners/ui-components';
import { ITEMS_TYPE } from '../../../utils';
import {
	Row,
	Cell,
	CellNumber,
	CellCheckbox,
	Text,
	LevelText,
	InfoIconWrapper,
	NumberText,
} from './TableRow.styles';
import {
	CheckboxWrapper,
	SpanWrapper,
	RowSpan,
	CellText,
	SpanColumn,
} from '../ItemsTable.styles';
import get from 'lodash/get';

export const TableRow = ({
	companies,
	data,
	spendFormatter,
	onItemChange,
	onGroupItemChange,
	items,
	highlightId,
	segments,
	showSegments,
	itemsType,
	showTopVendors,
	onTailItemsChange,
}) => {
	const {
		name,
		spend,
		level,
		segmentsByCompanies,
		headSpend,
		tailSpend,
		includeTailSpend,
	} = data;
	const isGroup = data.children && data.children.length > 0;

	const isGroupSelected = () => {
		const { children } = data;

		if (!children || !children.length) {
			return false;
		}

		return children.every(item =>
			items.some(
				node => node.name === item.name && node.groupName === item.groupName
			)
		);
	};

	const handleItemChange = () => {
		if (isGroup) {
			onGroupItemChange(data);
		} else {
			onItemChange(data);
		}
	};

	const handleTailItemChange = () => {
		onTailItemsChange(isGroup ? data.children : [data]);
	};

	const isPartiallyChecked =
		isGroup &&
		!isGroupSelected() &&
		data.children.some(item =>
			items.some(
				node => node.name === item.name && node.groupName === item.groupName
			)
		);
	const isFaded = isGroup
		? !!highlightId
		: highlightId && data.id !== highlightId;
	const hasSegments =
		showSegments && segments && itemsType === ITEMS_TYPE.TAIL_SPEND;
	const displayTopVendors =
		itemsType === ITEMS_TYPE.TAIL_SPEND || itemsType === ITEMS_TYPE.CATEGORY;

	const totalSpend =
		itemsType === ITEMS_TYPE.CATEGORY
			? includeTailSpend
				? headSpend + tailSpend
				: headSpend
			: spend;

	return (
		<Row
			isGroup={isGroup}
			isFaded={isFaded}
			selected={
				!isGroup &&
				items.find(
					node => node.name === data.name && node.groupName === data.groupName
				)
			}
			id={`${isGroup ? 'group' : 'leaf'}${data.id}`}
		>
			<Cell title={name}>
				{displayTopVendors && (
					<InfoIconWrapper
						onClick={() => {
							showTopVendors(data);
						}}
					>
						<ApIcon
							iconName="outline_info"
							iconSize={16}
							iconColor={colors.grey5}
						/>
					</InfoIconWrapper>
				)}

				<CheckboxWrapper>
					<ApCheckbox
						onClick={handleItemChange}
						onChange={() => {}}
						checked={
							isGroup
								? isGroupSelected()
								: items.some(
										node =>
											node.name === data.name &&
											node.groupName === data.groupName
								  )
						}
						indeterminate={isPartiallyChecked}
					/>
				</CheckboxWrapper>
				<Text>{name}</Text>
				{isGroup && <LevelText>&nbsp;(L{level})</LevelText>}
			</Cell>
			<CellNumber noBorder={hasSegments}>
				{spendFormatter(totalSpend)}
			</CellNumber>
			{itemsType === ITEMS_TYPE.CATEGORY && (
				<React.Fragment>
					<CellNumber>{spendFormatter(headSpend)}</CellNumber>

					<CellCheckbox>
						<CheckboxWrapper>
							<ApCheckbox
								onClick={handleTailItemChange}
								onChange={() => {}}
								checked={includeTailSpend}
								indeterminate={
									!includeTailSpend &&
									isGroup &&
									data.children.some(item => item.includeTailSpend)
								}
							/>
						</CheckboxWrapper>
						<NumberText>{spendFormatter(tailSpend)}</NumberText>
					</CellCheckbox>
				</React.Fragment>
			)}
			{hasSegments && (
				<SpanWrapper isGroup={isGroup}>
					<RowSpan>
						{segments.map(({ name }) => (
							<SpanColumn key={name} noBorder>
								<CellText>
									{spendFormatter(get(data, `segments.${name}`))}
								</CellText>
							</SpanColumn>
						))}
					</RowSpan>
				</SpanWrapper>
			)}
			{companies.map((companyName, index) => (
				<React.Fragment key={`${companyName}${index}`}>
					<CellNumber noBorder={hasSegments}>
						{spendFormatter(data.companies[companyName])}
					</CellNumber>
					{hasSegments && (
						<SpanWrapper isGroup={isGroup}>
							<RowSpan>
								{segments.map(({ name }) => (
									<SpanColumn key={name} noBorder>
										<CellText>
											{spendFormatter(
												get(segmentsByCompanies, `${name}.${companyName}`)
											)}
										</CellText>
									</SpanColumn>
								))}
							</RowSpan>
						</SpanWrapper>
					)}
				</React.Fragment>
			))}
		</Row>
	);
};

export default TableRow;
